// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1gtpT","colCheckbox":"styles_colCheckbox__1vwrl"};